<template>
  <!-- <div :class="props.dense ? '' : 'px-4 sm:px-6 lg:px-8 py-4 lg:py-8 '"> -->
  <div class="p-4 md:p-6 lg:p-10">
    <!-- <nav v-if="!props.dense" class="flex pb-2" aria-label="Breadcrumb">
      <ol role="list" class="flex items-center space-x-4">
        <li>
          <div>
            <a href="#" class="text-gray-400 hover:text-gray-500">
              <button
                @click="
                  $router.push({
                    name: 'projects',
                  })
                "
                class="text-sm font-medium text-gray-500 hover:text-gray-700"
              >
                <HomeIcon class="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                <span class="sr-only">Home</span>
              </button>
            </a>
          </div>
        </li>
        <li v-for="(page, idx) in pages" :key="page.label">
          <div class="flex items-center">
            <ChevronRightIcon
              class="h-5 w-5 flex-shrink-0 text-gray-400"
              aria-hidden="true"
            />
            <button
              class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              @click="$router.push({ name: page.name, params: page.params })"
              :disabled="idx === pages.length - 1"
            >
              {{ page.label }}
            </button>
          </div>
        </li>
      </ol>
    </nav> -->

    <div v-if="title && !props.dense" class="sm:flex sm:items-center pb-6">
      <div class="flex">
        <div class="lg:hidden pt-2 mr-2">
          <button
            type="button"
            class="-m-2.5 p-2.5 text-gray-700 dark:text-white lg:hidden"
            @click="store.triggerEvent('toggle-sidebar')"
          >
            <span class="sr-only">Open sidebar</span>
            <Bars3Icon class="h-6 w-6" aria-hidden="true" />
          </button>
        </div>

        <h1
          class="text-3xl font-bold leading-tight tracking-tight text-gray-900 dark:text-gray-100 h-9"
        >
          {{ title }}
        </h1>
      </div>
      <slot name="buttons"></slot>
    </div>
    <div
      :class="[
        title && !props.dense && !props.noBottomPadding ? 'py-4' : '',
        'dark:text-gray-100 ',
      ]"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script setup lang="ts">
import { Bars3Icon, ChevronRightIcon } from "@heroicons/vue/24/outline";
import { HomeIcon } from "@heroicons/vue/24/solid";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "@/store";

const route = useRoute();

const store = useStore();

const props = defineProps(["title", "dense", "noBottomPadding"]);

function routeMatches(name) {
  return route.matched.some((record) => record.name === name);
}

const pages = computed(() => {
  let path = [];
  if (
    ["project", "prompts", "datasets", "log", "evals"].some((r) =>
      routeMatches(r)
    )
  ) {
    path.push({
      label: "Project",
      name: "project",
      params: { id: route.params.id },
    });

    if (routeMatches("prompts")) {
      path.push({
        label: "Prompts",
        name: "prompts",
        params: { id: route.params.id },
      });
    } else if (routeMatches("datasets")) {
      path.push({
        label: "Test datasets",
        name: "datasetsRoot",
        params: { id: route.params.id },
      });

      if (routeMatches("datasetsDetails")) {
        path.push({
          label: "Test dataset",
          name: "datasetsDetails",
          params: {
            id: route.params.id,
            testdatasetid: route.params.testdatasetid,
          },
        });
      }
    } else if (routeMatches("evals")) {
      path.push({
        label: "Evaluations",
        name: "evalsRoot",
        params: {
          id: route.params.id,
        },
      });

      if (routeMatches("evalsDetails")) {
        path.push({
          label: "Evaluation results",
          name: "evalsDetails",
          params: {
            id: route.params.id,
            evaldatasetid: route.params.evaldatasetid,
          },
        });
      }
    } else if (routeMatches("log")) {
      path.push({
        label: "Log",
        name: "log",
        params: { id: route.params.id },
      });
    }
  }

  return path;
});
</script>
